export default __webpack_public_path__ + "static/media/ss6.b7b3f094.png";